import styled from 'styled-components';

export const Container = styled.div`
  padding-top: ${({ theme }) => theme.spacing(2)};
  margin: ${({ theme }) => `0 ${theme.spacing(6)} ${theme.spacing(1)}`};
`;

export const CompletedList = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing(6)}`};
`;
